import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '../material.module';
import { NgChartsModule } from 'ng2-charts';
import { NgApexchartsModule } from 'ng-apexcharts';
import { MomentModule } from 'ngx-moment';
import { DirectiveModule } from '../directive/directive.module';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { RecurringLoginComponent } from './recurring-auth/recurring-login/recurring-login.component';
import { TranslateModule } from '@ngx-translate/core';
import { TextFieldModule } from '@angular/cdk/text-field';
import { SlideCardComponent } from './examination/slide-card/slide-card.component';
import { SlideCardStudentComponent } from './examination/slide-card/slide-card-student/slide-card-student.component';
import { SlideCardTeacherComponent } from './examination/slide-card/slide-card-teacher/slide-card-teacher.component';
import { SlideCardStaffComponent } from './examination/slide-card/slide-card-staff/slide-card-staff.component';
import { LilateCardComponent } from './lilate-card/lilate-card.component';
import { FuseCardComponent } from '@fuse/components/card';
import { WebcamFuseComponent } from './webcam-fuse/webcam-fuse.component';
import { FuseAlertComponent } from '@fuse/components/alert';
import { SlideCardCriteriaComponent } from './slide-card-criteria/slide-card-criteria.component';
import { FeatureModule } from '../feature/feature.module';
import { ModalComponent, VideoStreamComponent } from './video-stream/video-stream.component';
import { PreviewExaminationComponent } from './preview/preview-examination/preview-examination.component';
import { YouTubePlayerModule } from '@angular/youtube-player';
import { PreviewExerciceComponent } from './preview/preview-exercice/preview-exercice.component';
import { ManageMediaExerciceFuseComponent, UrlVideoDialog } from './manage-media-exercice-fuse/manage-media-exercice-fuse.component';
import { ExaminationAssessmentComponent } from './examination/examination-assessment/examination-assessment.component';
import { ExaminationConclusionComponent } from './examination/examination-conclusion/examination-conclusion.component';
import { ExaminationInformationsComponent } from './examination/examination-informations/examination-informations.component';
import { ExaminationStepComponent } from './examination/examination-step/examination-step.component';
import { CheckIdComponent } from './examination/check-id/check-id.component';
import { LivePhotoRecaptureModalComponent } from './examination/live-photo-recapture-modal/live-photo-recapture-modal.component';import { PollFormComponent } from './poll-form/poll-form.component';
import { ExaminationCancelComponent } from './examination/examination-cancel/examination-cancel.component';
import { ParchmentLilateComponent } from './parchment-lilate/parchment.component';
import { ParchmentLilateV1Component } from './parchment-lilate/lilates/version1/parchment-lilate-v1.component';
import { ParchmentLilateV2Component } from './parchment-lilate/lilates/version2/parchment-lilate-v2.component';
import { Version1Component } from './parchment-lilate/grids/version1/version1.component';
import { Version2Component } from './parchment-lilate/grids/version2/version2.component';
import { RecurringResetPasswordComponent } from './recurring-auth/recurring-reset-password/recurring-reset-password.component';
import { RecurringForgotPasswordComponent } from './recurring-auth/recurring-forgot-password/recurring-forgot-password.component';
import { TestMediaComponent } from './test-media/test-media.component';
import { LoaderLilateComponent } from './loader-lilate/loader-lilate.component';
import { LilateCardDoneComponent } from './lilate-card/lilate-card-done/lilate-card-done.component';
import { LilateCardAbsentComponent } from './lilate-card/lilate-card-absent/lilate-card-absent.component';
import { LilateCardBookedComponent } from './lilate-card/lilate-card-booked/lilate-card-booked.component';
import { LilateCardCancelledByTeacherComponent } from './lilate-card/lilate-card-cancelled-by-teacher/lilate-card-cancelled-by-teacher.component';
import { LilateCardPendingBookingComponent } from './lilate-card/lilate-card-pending-booking/lilate-card-pending-booking.component';
import { LilateCardPendingAssessmentComponent } from './lilate-card/lilate-card-pending-assessment/lilate-card-pending-assessment.component';
import { LilateCardIdentityIssueComponent } from './lilate-card/lilate-card-identity-issue/lilate-card-identity-issue.component';
import { SafeInnerHtmlComponent } from './safe-inner-html/safe-inner-html.component';
import { ImageCropperPreviewFuseComponent } from './image-cropper-preview-fuse/image-cropper-preview-fuse.component';
import { TableCellStudentComponent } from './table-cell-student/table-cell-student.component';
import { TableCellTeacherComponent } from './table-cell-teacher/table-cell-teacher.component';
import { BirthdateFormFuseComponent } from './birthdate-form-fuse/birthdate-form-fuse.component';
import { GenderInputFuseComponent } from './gender-input-fuse/gender-input-fuse.component';
import { BookingLilateComponent } from './booking-lilate/booking-lilate.component';
import { NiveauFormComponent } from './booking-lilate/niveau-form/niveau-form.component';
import { LilatePathEventComponent } from './lilate-path-event/lilate-path-event.component';
import { LilateConnexionLogComponent } from './lilate-connexion-log/lilate-connexion-log.component';
import { CsatComponent } from './csat/csat.component';
import { NpsComponent } from './nps/nps.component';
import { LilateCreateTestingComponent } from './lilate-create-testing/lilate-create-testing.component';
import { OpenSessionFuseComponent } from './openSessionFuse/openSessionFuse.component';
import { AvatarComponent } from './avatar/avatar.component';
import { PonctualScheduleFuseComponent } from './ponctual-schedule-fuse/ponctual-schedule-fuse.component';
import { MenuProfilFuseComponent } from './menu-profil-fuse/menu-profil-fuse.component';
import { LilatePollResponseComponent } from './lilate-poll-response/lilate-poll-response.component';
import { ExportTableComponent } from './export-table/export-table.component';
import { JobFormFuseComponent } from './booking-lilate/job-form-fuse/job-form-fuse.component';
import { JobFormFuseStaffComponent } from './booking-lilate/job-form-fuse-staff/job-form-fuse-staff.component';
import { AIExamInformationsComponent } from './AI/AI-exam-informations/AI-exam-informations.component';
import { AIExamStepsComponent } from './AI/AI-exam-steps/AI-exam-steps.component';
import { AIExamSlideComponent } from './AI/AI-exam-slide/AI-exam-slide.component';
import { AiOpenComponent } from './AI/AI-exam-slide/exercises/ai-open/ai-open.component';
import { AiChoiceComponent } from './AI/AI-exam-slide/exercises/ai-choice/ai-choice.component';
import { AiFillBlankComponent } from './AI/AI-exam-slide/exercises/ai-fill-blank/ai-fill-blank.component';
import { AiOrderingComponent } from './AI/AI-exam-slide/exercises/ai-ordering/ai-ordering.component';
import { AiMatchingComponent } from './AI/AI-exam-slide/exercises/ai-matching/ai-matching.component';
import { AiTrueFalseComponent } from './AI/AI-exam-slide/exercises/ai-true-false/ai-true-false.component';
import { AiListeningPlayerComponent } from './AI/AI-exam-slide/exercises/ai-listening-player/ai-listening-player.component';
import { AIExamOnboardingComponent } from './AI/AI-exam-onboarding/AI-exam-onboarding.component';
import { JobFormFuseNoUserComponent } from './job-form-fuse-no-user/job-form-fuse-no-user.component';
import { JobFormAiOnboardingFuseComponent } from './job-form-ai-onboarding-fuse/job-form-ai-onboarding-fuse.component';
import { AIExamResultsComponent } from './AI/AI-exam-results/AI-exam-results.component';
import { AIExamExerciceResultsComponent } from './AI/AI-exam-exercice-result/AI-exam-exercice-results.component';
import { AIExamExerciceCriteriaComponent } from './AI/AI-exam-exercice-criteria/AI-exam-exercice-criteria.component';
import { SpeechVoiceComponent } from './speech-voice/speech-voice.component';
import { SpeechButtonComponent } from './speech-button/speech-button.component';
import { AudioRecorderComponent } from './AI/audio-recorder/audio-recorder.component';
import { AIExamTestMediaComponent } from './AI/AI-exam-test-media/AI-exam-test-media.component';
import { LanguagesTranslateFuseModule } from './languages-translate/languages-translate-fuse.module';
import { ImageCropperComponent } from 'ngx-image-cropper';
import { AIExamOnboardingLanguageSelectionComponent } from './AI/AI-exam-onboarding-language-selection/AI-exam-onboarding-language-selection.component';
import { AIExamOnboardingSkillsSelectionComponent } from './AI/AI-exam-onboarding-skills-selection/AI-exam-onboarding-skills-selection.component';
import { AIExamOnboardingPerceptionStepComponent } from './AI/AI-exam-onboarding-perception-step/AI-exam-onboarding-perception-step.component';
import { AiLoadingComponent } from './AI/AI-loading/AI-loading.component';
import { LilateExaminationSessionComponent } from './lilate-examination-session/lilate-examination-session.component';
import { MaintenanceFuseComponent } from './maintenance-fuse/maintenance-fuse.component';
import { MaintenanceFuseAnnouncementComponent } from './maintenance-fuse-announcement/maintenance-fuse-announcement.component';
import { AIExamOnboardingOtpComponent } from './AI/AI-exam-onboarding-otp/AI-exam-onboarding-otp.component';
import { AIExamOnboardingLegalComponent } from './AI/AI-exam-onboarding-legal/AI-exam-onboarding-legal.component';
import { AIExamOnboardingStripeIdentityComponent } from './AI/AI-exam-onboarding-stripe-identity/AI-exam-onboarding-stripe-identity.component';
import { AIExamOnboardingPersonalizationComponent } from './AI/AI-exam-onboarding-personalization/AI-exam-onboarding-personalization.component';
import { AIExamOnboardingProfessionalUniverseComponent } from './AI/AI-exam-onboarding-professional-universe/AI-exam-onboarding-professional-universe.component';
import { AIExamOnboardingDemoComponent } from './AI/AI-exam-onboarding-demo/AI-exam-onboarding-demo.component';
import { AIExamPreparationChecklistComponent } from './AI/AI-exam-preparation-checklist/AI-exam-preparation-checklist.component';
import { AIExamOnboardingShellComponent } from './AI/AI-exam-onboarding-shell/AI-exam-onboarding-shell.component';
import { AIExamOnboardingWelcomeProfileComponent } from './AI/AI-exam-onboarding-welcome-profile/AI-exam-onboarding-welcome-profile.component';
import { AIExamOnboardingPerceptionGaugesComponent } from './AI/AI-exam-onboarding-perception-gauges/AI-exam-onboarding-perception-gauges.component';
import { AIExamOnboardingComfortComponent } from './AI/AI-exam-onboarding-comfort/AI-exam-onboarding-comfort.component';
import { AIExamOnboardingDemoVideoComponent } from './AI/AI-exam-onboarding-demo-video/AI-exam-onboarding-demo-video.component';
import { AIExamOnboardingLaunchComponent } from './AI/AI-exam-onboarding-launch/AI-exam-onboarding-launch.component';
import { ExamTabSwitchAlertComponent } from './AI/exam-tab-switch-alert/exam-tab-switch-alert.component';
import { LilateNotificationsComponent } from './lilate-notifications/lilate-notifications.component';
import { ElateNotificationsComponent } from './elate-notifications/elate-notifications.component';
import { ExamNotificationsComponent } from './exam-notifications/exam-notifications.component';
import { TimezoneAutocompleteFuseComponent } from './timezone-autocomplete-fuse/timezone-autocomplete-fuse.component';
import { MailPreviewComponent } from './mail-preview/mail-preview.component';
import { ElatePollResponseComponent } from './elate-poll-response/elate-poll-response.component';
import { TargetedLevelFormComponent } from './booking-lilate/targeted-level-form/targeted-level-form.component';
import { LanguageSelectorFormComponent } from './booking-lilate/language-selector-form/language-selector-form.component';
import { PipeModule } from '../pipe.module';
import { ParisDayPipe } from '../pipe/paris-day.pipe';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { PonctualCalendarSelectorFuseComponent } from './ponctual-booking-fuse/ponctual-calendar-selector-fuse/ponctual-calendar-selector-fuse.component';
import { PonctualSelectionListFuseComponent } from './ponctual-booking-fuse/ponctual-selection-list-fuse/ponctual-selection-list-fuse.component';
import { PonctualConfirmButtonFuseComponent } from './ponctual-booking-fuse/ponctual-confirm-button-fuse/ponctual-confirm-button-fuse.component';
import { BirthdateInputFuseComponent } from './birthdate-input-fuse/birthdate-input-fuse.component';
import { NextSessionStudentComponent } from './next-session-student/next-session-student.component';
import { SfxService } from '../service/sfx.service';

@NgModule({
  imports: [
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    MomentModule,
    CommonModule,
    RouterModule,
    DirectiveModule,
    InfiniteScrollModule,
    TranslateModule.forChild(),
    TextFieldModule,
    FuseCardComponent,
    FuseAlertComponent,
    FeatureModule,
    LanguagesTranslateFuseModule,
    YouTubePlayerModule,
    ImageCropperComponent,
    LivePhotoRecaptureModalComponent,
    NgChartsModule,
    NgApexchartsModule,
    PipeModule,
    ParisDayPipe,
    DragDropModule,
    BirthdateInputFuseComponent,
    PonctualCalendarSelectorFuseComponent,
    PonctualSelectionListFuseComponent,
    PonctualConfirmButtonFuseComponent,
    AIExamOnboardingOtpComponent,
    AIExamOnboardingLegalComponent,
    AIExamOnboardingStripeIdentityComponent,
    AIExamOnboardingPersonalizationComponent,
    AIExamOnboardingProfessionalUniverseComponent,
    AIExamOnboardingDemoComponent,
    AIExamPreparationChecklistComponent,
    AIExamOnboardingShellComponent,
    AIExamOnboardingWelcomeProfileComponent,
    AIExamOnboardingPerceptionGaugesComponent,
    AIExamOnboardingComfortComponent,
    AIExamOnboardingDemoVideoComponent,
    AIExamOnboardingLaunchComponent,
    ExamTabSwitchAlertComponent,
    JobFormFuseNoUserComponent,
    JobFormAiOnboardingFuseComponent,
  ],
  declarations: [
    NextSessionStudentComponent,
    RecurringLoginComponent,
    SlideCardComponent,
    SlideCardStudentComponent,
    SlideCardTeacherComponent,
    SlideCardStaffComponent,
    LilateCardComponent,
    WebcamFuseComponent,
    SlideCardCriteriaComponent,
    VideoStreamComponent,
    PreviewExaminationComponent,
    PreviewExerciceComponent,
    ManageMediaExerciceFuseComponent,
    UrlVideoDialog,
    ExaminationAssessmentComponent,
    ExaminationConclusionComponent,
    ExaminationInformationsComponent,
    ExaminationStepComponent,
    CheckIdComponent,
    PollFormComponent,
    ExaminationCancelComponent,
    ParchmentLilateComponent,
    ParchmentLilateV2Component,
    ParchmentLilateV1Component,
    Version1Component,
    Version2Component,
    RecurringResetPasswordComponent,
    RecurringForgotPasswordComponent,
    TestMediaComponent,
    LoaderLilateComponent,
    LilateCardDoneComponent,
    LilateCardAbsentComponent,
    LilateCardBookedComponent,
    LilateCardCancelledByTeacherComponent,
    LilateCardPendingBookingComponent,
    LilateCardPendingAssessmentComponent,
    LilateCardIdentityIssueComponent,
    SafeInnerHtmlComponent,
    ImageCropperPreviewFuseComponent,
    BirthdateFormFuseComponent,
    GenderInputFuseComponent,
    TableCellStudentComponent,
    TableCellTeacherComponent,
    BirthdateFormFuseComponent,
    BookingLilateComponent,
    JobFormFuseComponent,
    JobFormFuseStaffComponent,
    NiveauFormComponent,
    LilatePathEventComponent,
    LilateConnexionLogComponent,
    CsatComponent,
    NpsComponent,
    LilateCreateTestingComponent,
    OpenSessionFuseComponent,
    AvatarComponent,
    PonctualScheduleFuseComponent,
    MenuProfilFuseComponent,
    LilatePollResponseComponent,
    ExportTableComponent,
    AIExamInformationsComponent,
    AIExamStepsComponent,
    AIExamSlideComponent,
    AiOpenComponent,
    AiChoiceComponent,
    AiListeningPlayerComponent,
    AiFillBlankComponent,
    AiOrderingComponent,
    AiMatchingComponent,
    AiTrueFalseComponent,
    AIExamOnboardingComponent,
    AIExamResultsComponent,
    AIExamExerciceResultsComponent,
    AIExamExerciceCriteriaComponent,
    SpeechVoiceComponent,
    SpeechButtonComponent,
    AudioRecorderComponent,
    AIExamTestMediaComponent,
    AIExamOnboardingLanguageSelectionComponent,
    AIExamOnboardingSkillsSelectionComponent,
    AIExamOnboardingPerceptionStepComponent,
    AiLoadingComponent,
    LilateExaminationSessionComponent,
    MaintenanceFuseComponent,
    MaintenanceFuseAnnouncementComponent,
    ModalComponent,
    LilateNotificationsComponent,
    ElateNotificationsComponent,
    ExamNotificationsComponent,
    TimezoneAutocompleteFuseComponent,
    MailPreviewComponent,
    ElatePollResponseComponent,
    TargetedLevelFormComponent,
    LanguageSelectorFormComponent,
  ],
  providers: [
    SfxService,
  ],
  exports: [
    NextSessionStudentComponent,
    RecurringLoginComponent,
    SlideCardComponent,
    SlideCardStudentComponent,
    SlideCardTeacherComponent,
    SlideCardStaffComponent,
    LilateCardComponent,
    WebcamFuseComponent,
    SlideCardCriteriaComponent,
    VideoStreamComponent,
    PreviewExaminationComponent,
    PreviewExerciceComponent,
    ManageMediaExerciceFuseComponent,
    ExaminationAssessmentComponent,
    ExaminationConclusionComponent,
    ExaminationInformationsComponent,
    ExaminationStepComponent,
    CheckIdComponent,
    LivePhotoRecaptureModalComponent,
    PollFormComponent,
    ExaminationCancelComponent,
    ParchmentLilateV2Component,
    ParchmentLilateV1Component,
    RecurringResetPasswordComponent,
    RecurringForgotPasswordComponent,
    TestMediaComponent,
    LoaderLilateComponent,
    LilateCardDoneComponent,
    LilateCardAbsentComponent,
    LilateCardBookedComponent,
    LilateCardCancelledByTeacherComponent,
    LilateCardPendingBookingComponent,
    LilateCardPendingAssessmentComponent,
    LilateCardIdentityIssueComponent,
    ImageCropperPreviewFuseComponent,
    BirthdateFormFuseComponent,
    GenderInputFuseComponent,
    TableCellStudentComponent,
    TableCellTeacherComponent,
    BirthdateFormFuseComponent,
    BookingLilateComponent,
    LilatePathEventComponent,
    LilateConnexionLogComponent,
    CsatComponent,
    NpsComponent,
    LilateCreateTestingComponent,
    OpenSessionFuseComponent,
    AvatarComponent,
    PonctualScheduleFuseComponent,
    MenuProfilFuseComponent,
    LilatePollResponseComponent,
    ExportTableComponent,
    JobFormFuseComponent,
    JobFormFuseStaffComponent,
    AIExamInformationsComponent,
    AIExamStepsComponent,
    AIExamSlideComponent,
    AIExamOnboardingComponent,
    JobFormFuseNoUserComponent,
    AIExamResultsComponent,
    AIExamExerciceResultsComponent,
    AIExamExerciceCriteriaComponent,
    SpeechVoiceComponent,
    SpeechButtonComponent,
    AudioRecorderComponent,
    AIExamTestMediaComponent,
    LanguagesTranslateFuseModule,
    AIExamOnboardingLanguageSelectionComponent,
    AIExamOnboardingSkillsSelectionComponent,
    AIExamOnboardingPerceptionStepComponent,
    AiLoadingComponent,
    LilateExaminationSessionComponent,
    MaintenanceFuseComponent,
    MaintenanceFuseAnnouncementComponent,
    LilateNotificationsComponent,
    ElateNotificationsComponent,
    ExamNotificationsComponent,
    TimezoneAutocompleteFuseComponent,
    MailPreviewComponent,
    ElatePollResponseComponent,
    TargetedLevelFormComponent,
    LanguageSelectorFormComponent,
    BirthdateInputFuseComponent,
  ]
})
export class FeatureFuseModule { }
